import React from "react";
import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";

export default function TComment(props) {
  const { answers, required, register, errors } = props;

  return (
    <TextField
      variant="outlined"
      fullWidth
      type="text"
      name="answer"
      multiline
      rows={2}
      error={errors.answer ? true : false}
      helperText={errors.answer ? "Ingrese una respuesta" : ""}
      defaultValue={answers[0].selected}
      inputRef={register({ required: required })}
    />
  );
}

TComment.propTypes = {
  answers: PropTypes.array.isRequired,
  required: PropTypes.bool,
  register: PropTypes.func,
  errors: PropTypes.object,
};
